import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';
import { TrainerLink } from '../../../shared/links/ProfileLink';

const Trainer = ({
    hasPedigree,
    trainerName,
    trainerUid,
    isWeatherbysMobile,
    trainerLast14Days: {
        wins,
        runs,
        percent,
    },
}) => (
    trainerUid ? (
        <Definition term={isWeatherbysMobile ? '' : 'Trainer'}>
            <TrainerLink
                trainerStyleName={trainerName}
                trainerUid={trainerUid}
            />
            {!hasPedigree && !!runs && (
                <span className="hp-details__info">
                    &nbsp;(Last 14 days: {wins}-{runs}, {percent}%)
                </span>
            )}
        </Definition>
    ) : null
);

Trainer.propTypes = {
    hasPedigree: PropTypes.bool,
    trainerName: PropTypes.string,
    trainerUid: PropTypes.number,
    isWeatherbysMobile: PropTypes.bool,
    trainerLast14Days: PropTypes.shape({
        wins: PropTypes.number,
        runs: PropTypes.number,
        percent: PropTypes.number,
    }),
};

export default Trainer;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Trainer.jsx